export const getJSON = (url) => {
  let array = url.replace('?', '')
    , params = {}
  array.split('&')
    .forEach(element => {
      let value = element.split('=')
      params[value[0]] = value[1]
    })
  return params
}